import 'css-chunksrc/feature/modifier/ModifierCard.module.scss';export default {
  "root": "ModifierCard_root",
  "button_container": "ModifierCard_button_container"
};